// ==========================================================
// Compartir una convocatoria por WhatsApp.
//
// El mensaje se arma en el mismo clic y se abre wa.me al instante:
// sin esperas, sin pestaña intermedia y sin depender de ningún
// servicio externo (un acortador desde el navegador necesitaría
// CORS y un backend que esta app no tiene).
// ==========================================================

// Devuelve el enlace de bases si es usable, o null.
export function enlaceDeBases(value) {
  try {
    const url = new URL(String(value || '').trim());
    if (!['https:', 'http:'].includes(url.protocol)) return null;
    if (url.username || url.password) return null;
    return url.href;
  } catch (e) {
    return null;
  }
}

export function buildConvocatoriaMessage(proceso, enlace, titulo) {
  const fecha = (value) => {
    if (!value) return 'No indicada';
    const date = new Date(value);
    return Number.isNaN(date.getTime())
      ? 'No indicada'
      : date.toLocaleString('es-PE', {
          timeZone: 'America/Lima',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
  };

  const lineas = [
    '*' + (titulo || 'SEACE · Nueva convocatoria') + '*',
    '',
    '*Nomenclatura:* ' + (proceso.nomenclatura || 'No indicada'),
    '*Entidad:* ' + (proceso.entidad || 'No indicada'),
    '*Descripción:* ' + (proceso.descripcion_proceso || 'No indicada'),
    '*Objeto:* ' + (proceso.objet || 'No indicado'),
    '*Procedimiento:* ' + (proceso.tipo_proceso || 'No indicado'),
    '*Ubicación:* ' +
      ([proceso.departamento, proceso.provincia, proceso.distrito].filter(Boolean).join(' · ') || 'No indicada'),
    '*Cierre de registro:* ' + fecha(proceso.fecha_fin_participantes),
    '*Presentación de ofertas:* ' + fecha(proceso.fecha_presentacion_propuestas)
  ];

  if (enlace) lineas.push('', '*Bases / PDF:* ' + enlace);

  lineas.push('', 'Compartido desde LicitaHUB');
  return lineas.join('\n');
}

export function whatsappShareUrl(texto) {
  return 'https://wa.me/?text=' + encodeURIComponent(texto);
}
